import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
/**
 *  Property helper functions.
 *
 *  @_subsection api/utils:Properties  [about-properties]
 */
function checkType(value, type, name) {
  var types = type.split("|").map(function (t) {
    return t.trim();
  });
  for (var i = 0; i < types.length; i++) {
    switch (type) {
      case "any":
        return;
      case "bigint":
      case "boolean":
      case "number":
      case "string":
        if (typeof value === type) {
          return;
        }
    }
  }
  var error = new Error("invalid value for type ".concat(type));
  error.code = "INVALID_ARGUMENT";
  error.argument = "value.".concat(name);
  error.value = value;
  throw error;
}
/**
 *  Resolves to a new object that is a copy of %%value%%, but with all
 *  values resolved.
 */
export function resolveProperties(_x) {
  return _resolveProperties.apply(this, arguments);
}
/**
 *  Assigns the %%values%% to %%target%% as read-only values.
 *
 *  It %%types%% is specified, the values are checked.
 */
function _resolveProperties() {
  _resolveProperties = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
    var keys, results;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          keys = Object.keys(value);
          _context.next = 3;
          return Promise.all(keys.map(function (k) {
            return Promise.resolve(value[k]);
          }));
        case 3:
          results = _context.sent;
          return _context.abrupt("return", results.reduce(function (accum, v, index) {
            accum[keys[index]] = v;
            return accum;
          }, {}));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _resolveProperties.apply(this, arguments);
}
export function defineProperties(target, values, types) {
  for (var key in values) {
    var value = values[key];
    var type = types ? types[key] : null;
    if (type) {
      checkType(value, type, key);
    }
    Object.defineProperty(target, key, {
      enumerable: true,
      value: value,
      writable: false
    });
  }
}